<template>
  <div style="display:flex;width: fit-content;">
      <div
        v-if="hasQuoteContent"
        :class="{
          'reference-content': true,
          reverse: message.flow === 'out',
          in:message.flow === 'in',
          isMobile: isH5,
          isPc: isPC,
        }"
        @click="scrollToOriginalMessage"
      >
        
        <div
          v-if="isMessageRevoked"
          :class="isPC ? 'revoked-text' : ''"
        >
          {{ TUITranslateService.t("TUIChat.引用内容已撤回") }}
        </div>
        <div v-else>
          <div v-if="isH5" class="mobile-quote-sender">
            {{ quoteMessageSender }}
          </div>
          <div
            class="max-double-line"
          >
          {{ isPC ? quoteMessageSender + ": "+ transformTextWithKeysToEmojiNames(messageQuoteText) : transformTextWithKeysToEmojiNames(messageQuoteText)}}
          </div>
        </div>
        
      </div>
</div>
  
</template>

<script lang="ts">
import vue from '../../../../../adapter-vue';
import { TUIStore, StoreName, IMessageModel, TUITranslateService } from '../../../../../@aidesk/uikit-engine';
import { getBoundingClientRect, getScrollInfo } from '@tencentcloud/universal-api';
import { isH5, isPC } from '../../../../../utils/env';
import { Toast, TOAST_TYPE } from '../../../../../components/common/Toast/index-web';
import { ICloudCustomData, IQuoteContent, MessageQuoteTypeEnum } from './interface.ts';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config';
export interface IProps {
  message: IMessageModel;
}
export interface IEmits {
  (e: 'scrollTo', scrollHeight: number): void;
  (e: 'blinkMessage', messageID: string | undefined): void;
}
const __sfc_main = {};
__sfc_main.props = {
  message: {
    key: "message",
    required: false,
    type: null,
    default: () => ({}) as IMessageModel
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    computed,
    ref,
    onMounted
  } = vue;
  const emits = __ctx.emit;
  const props = __props;
  let selfAddValue = 0;
  const messageQuoteText = ref<string>('');
  const hasQuoteContent = ref(false);
  const messageQuoteContent = ref<IQuoteContent>({} as IQuoteContent);
  const quoteMessageSender = ref<string>('');
  const isMessageRevoked = computed<boolean>(() => {
    try {
      const cloudCustomData: ICloudCustomData = JSON.parse(props.message?.cloudCustomData || '{}');
      const quotedMessageModel = TUIStore.getMessageModel(cloudCustomData.messageReply.messageID);
      return quotedMessageModel?.isRevoked;
    } catch (error) {
      return true;
    }
  });
  onMounted(() => {
    try {
      const cloudCustomData: ICloudCustomData = JSON.parse(props.message?.cloudCustomData || '{}');
      hasQuoteContent.value = Boolean(cloudCustomData.messageReply);
      if (hasQuoteContent.value) {
        messageQuoteContent.value = cloudCustomData.messageReply;
        messageQuoteText.value = performQuoteContent(messageQuoteContent.value);
      }
    } catch (error) {
      hasQuoteContent.value = false;
    }
  });
  function performQuoteContent(params: IQuoteContent) {
    let messageKey: string = '';
    let quoteContent: string = '';
    const quoteMessage = getQuoteMessage(params.messageID);
    switch (params.messageType) {
      case MessageQuoteTypeEnum.TYPE_TEXT:
        messageKey = '[文本]';
        break;
      case MessageQuoteTypeEnum.TYPE_CUSTOM:
        messageKey = '[自定义消息]';
        break;
      case MessageQuoteTypeEnum.TYPE_IMAGE:
        messageKey = '[图片]';
        break;
      case MessageQuoteTypeEnum.TYPE_SOUND:
        messageKey = '[音频]';
        break;
      case MessageQuoteTypeEnum.TYPE_VIDEO:
        messageKey = '[视频]';
        break;
      case MessageQuoteTypeEnum.TYPE_FILE:
        messageKey = '[文件]';
        break;
      case MessageQuoteTypeEnum.TYPE_LOCATION:
        messageKey = '[地理位置]';
        break;
      case MessageQuoteTypeEnum.TYPE_FACE:
        messageKey = '[动画表情]';
        break;
      case MessageQuoteTypeEnum.TYPE_GROUP_TIPS:
        messageKey = '[群提示]';
        break;
      case MessageQuoteTypeEnum.TYPE_MERGER:
        messageKey = '[聊天记录]';
        break;
      default:
        messageKey = '[消息]';
        break;
    }
    if (params.messageType === MessageQuoteTypeEnum.TYPE_CUSTOM || params.messageType === MessageQuoteTypeEnum.TYPE_TEXT || params.messageType === MessageQuoteTypeEnum.TYPE_MERGER) {
      quoteContent = params.messageAbstract;
    }
    quoteMessageSender.value = !quoteMessage ? messageQuoteContent.value.messageSender : quoteMessage.nick || quoteMessage.from;
    return quoteContent ? quoteContent : TUITranslateService.t(`TUIChat.${messageKey}`);
  }
  function getQuoteMessage(messageID: string) {
    const currentMessageList = TUIStore.getData(StoreName.CHAT, 'messageList');
    let quoteMessage = currentMessageList.find(message => message.ID === messageID);
    return quoteMessage;
  }
  async function scrollToOriginalMessage() {
    if (isMessageRevoked.value) {
      return;
    }
    const originMessageID = messageQuoteContent.value?.messageID;
    const currentMessageList = TUIStore.getData(StoreName.CHAT, 'messageList');
    const isOriginalMessageInScreen = currentMessageList.some(message => message.ID === originMessageID);
    if (originMessageID && isOriginalMessageInScreen) {
      try {
        const scrollViewRect = await getBoundingClientRect('#messageScrollList', 'messageList');
        const originalMessageRect = await getBoundingClientRect('#tui-' + originMessageID, 'messageList');
        const {
          scrollTop
        } = await getScrollInfo('#messageScrollList', 'messageList');
        const finalScrollTop = originalMessageRect.top + scrollTop - scrollViewRect.top - selfAddValue++ % 2;
        const isNeedScroll = originalMessageRect.top < scrollViewRect.top;
        if (window) {
          const scrollView = document.getElementById('messageScrollList');
          if (isNeedScroll && scrollView) {
            scrollView.scrollTop = finalScrollTop;
          }
        }
        emits('blinkMessage', originMessageID);
      } catch (error) {
        console.error(error);
      }
    } else {
      Toast({
        message: TUITranslateService.t('TUIChat.无法定位到原消息'),
        type: TOAST_TYPE.WARNING
      });
    }
  }
  return {
    TUITranslateService,
    isH5,
    isPC,
    transformTextWithKeysToEmojiNames,
    messageQuoteText,
    hasQuoteContent,
    quoteMessageSender,
    isMessageRevoked,
    scrollToOriginalMessage
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
.reference-content {
  max-width: 272px;
  margin-top: 4px;
  
  padding: 12px;
  font-size: 12px;
  color: #666;
  overflow-wrap: break-word;
  word-break: normal;
  background-color: #fbfbfb;
  border-radius: 8px;
  line-height: 16.8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.reference-content.isPc {
  margin-left: 44px;
}

.reverse.reference-content {
  margin-right: 44px;
  margin-left: auto;
  border-radius: 8px;
}
.isMobile.reference-content.in {
  margin-right: auto;
  background: #f3f4f7;
  border-radius: 8px;
}
.isMobile.reverse.reference-content {
  margin-right: 10px;
  margin-left: auto;
  background: #FFFFFF1A;
  color: white;
  
}
.revoked-text {
  color: #999;
}

.mobile-quote-sender{
  font-size: 10px;
}

.max-double-line {
  font-size: 14px;
  overflow-wrap: break-word;
  word-break: normal;
  overflow: hidden;
  display: -webkit-box;
  max-height: 33px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
